import Vue from "vue";
import App from "./App.vue";
import router from "@/router";
import store from "@/store";
// import "animate.css";
// import "@/assets/font/font.css";

// 防止多次点击
// import preventReClick from '@/utils/preventReClick.js'
// Vue.use(preventReClick);

import VueAwesomeSwiper from 'vue-awesome-swiper'
//引入样式
import 'swiper/swiper.min.css'
Vue.use(VueAwesomeSwiper, /* { 全局组件的默认选项 } */)


// VueEasytable
// 引入样式
import "vue-easytable/libs/theme-default/index.css";
// 引入组件库
// import { VeTable, VePagination, VeIcon, VeLoading, VeLocale } from "vue-easytable";
import { VeTable, VePagination, VeLoading, VeLocale } from "vue-easytable";
Vue.use(VeTable);
Vue.use(VePagination);
Vue.use(VeLoading);
Vue.prototype.$veLoading = VeLoading;
Vue.prototype.$veLocale = VeLocale;

import jsCookie from 'js-cookie'
Vue.prototype.$cookie = jsCookie;  // 在页面里可直接用 this.$cookie 调用


// 滚动条
var VueScrollTo = require('vue-scrollto');
Vue.use(VueScrollTo)

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount("#app");
